export const videoLinkXero = 'https://approvalmax.com/hubfs/Video%20guides/Final_GuideVideo1_4.mp4';
export const videoLinkQBooks = 'https://approvalmax.com/hubfs/Video%20guides/Final_GuideVideo1_QBO_2.mp4';
